import { ANNOTATION_VALUE } from "@/constants/annotation-values"

const normalizeYesNoValue = (value: number | null | undefined): -1 | 0 | 1 => {
  if (value === 1 || value === 0) {
    return value
  }
  return -1
}

/**
 * Derive "YES" | "NO" | "UNKNOWN" from a MetricOutput-like object.
 * Prefers string_value (canonical for output_type "string") and falls back
 * to float_value for legacy metric outputs.
 */
export const deriveYesNoString = (mo: {
  float_value?: number | null
  string_value?: string | null
}): "YES" | "NO" | "UNKNOWN" => {
  const sv = mo.string_value?.trim().toUpperCase() ?? null
  if (
    sv === ANNOTATION_VALUE.YES ||
    sv === ANNOTATION_VALUE.NO ||
    sv === ANNOTATION_VALUE.UNKNOWN
  ) {
    return sv
  }
  // Fallback to float_value for legacy metric outputs
  if (mo.float_value != null) {
    const n = normalizeYesNoValue(mo.float_value)
    return n === 1
      ? ANNOTATION_VALUE.YES
      : n === 0
        ? ANNOTATION_VALUE.NO
        : ANNOTATION_VALUE.UNKNOWN
  }
  return ANNOTATION_VALUE.UNKNOWN
}
